export enum NotificationStatus {
  All = 'all',
  Unread = 'unread',
  Read = 'read',
}
